import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  AssertionError3yq7q0knw9m5 as AssertionError,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { EOFException34hypof9gkxss as EOFException } from './NonJvmPlatform.mjs';
import { checkOffsetAndCount2b5icqlx5z1pu as checkOffsetAndCount } from './Util.mjs';
import {
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  subtract2orl8z9upxd9l as subtract,
  convertToInty04h231mmjoh as convertToInt,
  numberToLong2pakxeg38estk as numberToLong,
} from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SegmentPool_instance23prvj6kllmmf as SegmentPool_instance } from './SegmentPool.mjs';
import {
  ByteString2qc03wzjsovk as ByteString,
  Companion_getInstance2g1g1maz1t653 as Companion_getInstance,
} from './ByteString.mjs';
import { commonToUtf8Stringyih6e1qg1yoo as commonToUtf8String } from './internal/-Utf8.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { toByte4i43936u611k as toByte } from '../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  readUtf8Line36yidw3sdfobh as readUtf8Line,
  selectPrefix5tb3rl5iltlw as selectPrefix,
  rangeEquals13q7f5dia0en as rangeEquals,
} from './internal/Buffer.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { SegmentedByteString5e5x58c4yl7l as SegmentedByteString } from './SegmentedByteString.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var UnsafeCursorClass;
function UnsafeCursor() {
  if (UnsafeCursorClass === VOID) {
    class $ {
      constructor() {
        this.k3x_1 = null;
        this.l3x_1 = false;
        this.m3x_1 = null;
        this.n3x_1 = -1n;
        this.o3x_1 = null;
        this.p3x_1 = -1;
        this.q3x_1 = -1;
      }
      l6() {
        // Inline function 'okio.internal.commonClose' call
        // Inline function 'kotlin.check' call
        if (!!(this.k3x_1 == null)) {
          var message = 'not attached to a buffer';
          throw IllegalStateException().o(toString(message));
        }
        this.k3x_1 = null;
        this.m3x_1 = null;
        this.n3x_1 = -1n;
        this.o3x_1 = null;
        this.p3x_1 = -1;
        this.q3x_1 = -1;
      }
    }
    initMetadataForClass($, 'UnsafeCursor', UnsafeCursor);
    UnsafeCursorClass = $;
  }
  return UnsafeCursorClass;
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.a3v_1 = null;
        this.b3v_1 = 0n;
      }
      r3x() {
        return this;
      }
      s3x() {
        return this.b3v_1 === 0n;
      }
      t3x(byteCount) {
        if (this.b3v_1 < byteCount)
          throw EOFException().x3x(null);
      }
      y3x(byteCount) {
        return this.b3v_1 >= byteCount;
      }
      z3x(out, offset, byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonCopyTo' call
          var offset_0 = offset;
          var byteCount_0 = byteCount;
          checkOffsetAndCount(this.b3v_1, offset_0, byteCount_0);
          if (byteCount_0 === 0n) {
            tmp$ret$0 = this;
            break $l$block;
          }
          out.b3v_1 = add(out.b3v_1, byteCount_0);
          var s = this.a3v_1;
          while (offset_0 >= fromInt(ensureNotNull(s).s3v_1 - s.r3v_1 | 0)) {
            offset_0 = subtract(offset_0, fromInt(s.s3v_1 - s.r3v_1 | 0));
            s = s.v3v_1;
          }
          while (byteCount_0 > 0n) {
            var copy = ensureNotNull(s).z3v();
            copy.r3v_1 = copy.r3v_1 + convertToInt(offset_0) | 0;
            var tmp = copy;
            var tmp0 = copy.r3v_1 + convertToInt(byteCount_0) | 0;
            // Inline function 'kotlin.comparisons.minOf' call
            var b = copy.s3v_1;
            tmp.s3v_1 = Math.min(tmp0, b);
            if (out.a3v_1 == null) {
              copy.w3v_1 = copy;
              copy.v3v_1 = copy.w3v_1;
              out.a3v_1 = copy.v3v_1;
            } else {
              ensureNotNull(ensureNotNull(out.a3v_1).w3v_1).b3w(copy);
            }
            byteCount_0 = subtract(byteCount_0, fromInt(copy.s3v_1 - copy.r3v_1 | 0));
            offset_0 = 0n;
            s = s.v3v_1;
          }
          tmp$ret$0 = this;
        }
        return tmp$ret$0;
      }
      o3w(pos) {
        var tmp$ret$0;
        $l$block_3: {
          // Inline function 'okio.internal.commonGet' call
          checkOffsetAndCount(this.b3v_1, pos, 1n);
          $l$block_4: {
            // Inline function 'okio.internal.seek' call
            var tmp0_elvis_lhs = this.a3v_1;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$0 = ensureNotNull(null).q3v_1[convertToInt(subtract(add(numberToLong(null.r3v_1), pos), -1n))];
              break $l$block_3;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var s = tmp;
            if (subtract(this.b3v_1, pos) < pos) {
              var offset = this.b3v_1;
              while (offset > pos) {
                s = ensureNotNull(s.w3v_1);
                offset = subtract(offset, fromInt(s.s3v_1 - s.r3v_1 | 0));
              }
              var tmp0 = s;
              var offset_0 = offset;
              tmp$ret$0 = ensureNotNull(tmp0).q3v_1[convertToInt(subtract(add(numberToLong(tmp0.r3v_1), pos), offset_0))];
              break $l$block_3;
            } else {
              var offset_1 = 0n;
              $l$loop: while (true) {
                var tmp0_0 = offset_1;
                // Inline function 'kotlin.Long.plus' call
                var other = s.s3v_1 - s.r3v_1 | 0;
                var nextOffset = add(tmp0_0, fromInt(other));
                if (nextOffset > pos)
                  break $l$loop;
                s = ensureNotNull(s.v3v_1);
                offset_1 = nextOffset;
              }
              var tmp0_1 = s;
              var offset_2 = offset_1;
              tmp$ret$0 = ensureNotNull(tmp0_1).q3v_1[convertToInt(subtract(add(numberToLong(tmp0_1.r3v_1), pos), offset_2))];
              break $l$block_3;
            }
          }
        }
        return tmp$ret$0;
      }
      a3y() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonCompleteSegmentByteCount' call
          var result = this.b3v_1;
          if (result === 0n) {
            tmp$ret$0 = 0n;
            break $l$block;
          }
          var tail = ensureNotNull(ensureNotNull(this.a3v_1).w3v_1);
          if (tail.s3v_1 < 8192 && tail.u3v_1) {
            result = subtract(result, fromInt(tail.s3v_1 - tail.r3v_1 | 0));
          }
          tmp$ret$0 = result;
        }
        return tmp$ret$0;
      }
      b3y() {
        // Inline function 'okio.internal.commonReadByte' call
        if (this.b3v_1 === 0n)
          throw EOFException().c3y();
        var segment = ensureNotNull(this.a3v_1);
        var pos = segment.r3v_1;
        var limit = segment.s3v_1;
        var data = segment.q3v_1;
        var tmp0 = pos;
        pos = tmp0 + 1 | 0;
        var b = data[tmp0];
        this.b3v_1 = subtract(this.b3v_1, 1n);
        if (pos === limit) {
          this.a3v_1 = segment.a3w();
          SegmentPool_instance.i3w(segment);
        } else {
          segment.r3v_1 = pos;
        }
        return b;
      }
      n3v() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonReadInt' call
          if (this.b3v_1 < 4n)
            throw EOFException().c3y();
          var segment = ensureNotNull(this.a3v_1);
          var pos = segment.r3v_1;
          var limit = segment.s3v_1;
          if (fromInt(limit - pos | 0) < 4n) {
            // Inline function 'okio.and' call
            var tmp = (this.b3y() & 255) << 24;
            // Inline function 'okio.and' call
            var tmp_0 = tmp | (this.b3y() & 255) << 16;
            // Inline function 'okio.and' call
            var tmp_1 = tmp_0 | (this.b3y() & 255) << 8;
            // Inline function 'okio.and' call
            tmp$ret$0 = tmp_1 | this.b3y() & 255;
            break $l$block;
          }
          var data = segment.q3v_1;
          var tmp3 = pos;
          pos = tmp3 + 1 | 0;
          // Inline function 'okio.and' call
          var tmp_2 = (data[tmp3] & 255) << 24;
          var tmp2 = pos;
          pos = tmp2 + 1 | 0;
          // Inline function 'okio.and' call
          var tmp_3 = tmp_2 | (data[tmp2] & 255) << 16;
          var tmp1 = pos;
          pos = tmp1 + 1 | 0;
          // Inline function 'okio.and' call
          var tmp_4 = tmp_3 | (data[tmp1] & 255) << 8;
          var tmp0 = pos;
          pos = tmp0 + 1 | 0;
          // Inline function 'okio.and' call
          var i = tmp_4 | data[tmp0] & 255;
          this.b3v_1 = subtract(this.b3v_1, 4n);
          if (pos === limit) {
            this.a3v_1 = segment.a3w();
            SegmentPool_instance.i3w(segment);
          } else {
            segment.r3v_1 = pos;
          }
          tmp$ret$0 = i;
        }
        return tmp$ret$0;
      }
      d3y() {
        // Inline function 'okio.internal.commonReadByteString' call
        return this.e3y(this.b3v_1);
      }
      e3y(byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadByteString' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n && byteCount <= 2147483647n)) {
            var message = 'byteCount: ' + byteCount.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          if (this.b3v_1 < byteCount)
            throw EOFException().c3y();
          if (byteCount >= 4096n) {
            // Inline function 'kotlin.also' call
            var this_0 = this.g3y(convertToInt(byteCount));
            this.c3v(byteCount);
            tmp$ret$0 = this_0;
            break $l$block_0;
          } else {
            tmp$ret$0 = new (ByteString())(this.f3y(byteCount));
            break $l$block_0;
          }
        }
        return tmp$ret$0;
      }
      h3y() {
        return this.p3w(this.b3v_1);
      }
      p3w(byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadUtf8' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n && byteCount <= 2147483647n)) {
            var message = 'byteCount: ' + byteCount.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          if (this.b3v_1 < byteCount)
            throw EOFException().c3y();
          if (byteCount === 0n) {
            tmp$ret$0 = '';
            break $l$block_0;
          }
          var s = ensureNotNull(this.a3v_1);
          if (add(numberToLong(s.r3v_1), byteCount) > fromInt(s.s3v_1)) {
            tmp$ret$0 = commonToUtf8String(this.f3y(byteCount));
            break $l$block_0;
          }
          var result = commonToUtf8String(s.q3v_1, s.r3v_1, s.r3v_1 + convertToInt(byteCount) | 0);
          s.r3v_1 = s.r3v_1 + convertToInt(byteCount) | 0;
          this.b3v_1 = subtract(this.b3v_1, byteCount);
          if (s.r3v_1 === s.s3v_1) {
            this.a3v_1 = s.a3w();
            SegmentPool_instance.i3w(s);
          }
          tmp$ret$0 = result;
        }
        return tmp$ret$0;
      }
      i3y() {
        return this.j3y(9223372036854775807n);
      }
      j3y(limit) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadUtf8LineStrict' call
          // Inline function 'kotlin.require' call
          if (!(limit >= 0n)) {
            var message = 'limit < 0: ' + limit.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          var scanLength = limit === 9223372036854775807n ? 9223372036854775807n : add(limit, 1n);
          // Inline function 'kotlin.code' call
          var this_0 = _Char___init__impl__6a9atx(10);
          var tmp$ret$3 = Char__toInt_impl_vasixd(this_0);
          var newline = this.k3y(toByte(tmp$ret$3), 0n, scanLength);
          if (!(newline === -1n)) {
            tmp$ret$0 = readUtf8Line(this, newline);
            break $l$block_0;
          }
          var tmp;
          var tmp_0;
          if (scanLength < this.b3v_1) {
            // Inline function 'kotlin.Long.minus' call
            var tmp$ret$4 = subtract(scanLength, fromInt(1));
            var tmp_1 = this.o3w(tmp$ret$4);
            // Inline function 'kotlin.code' call
            var this_1 = _Char___init__impl__6a9atx(13);
            var tmp$ret$5 = Char__toInt_impl_vasixd(this_1);
            tmp_0 = tmp_1 === toByte(tmp$ret$5);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            var tmp_2 = this.o3w(scanLength);
            // Inline function 'kotlin.code' call
            var this_2 = _Char___init__impl__6a9atx(10);
            var tmp$ret$6 = Char__toInt_impl_vasixd(this_2);
            tmp = tmp_2 === toByte(tmp$ret$6);
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = readUtf8Line(this, scanLength);
            break $l$block_0;
          }
          var data = new (Buffer())();
          // Inline function 'okio.minOf' call
          var b = this.b3v_1;
          // Inline function 'kotlin.comparisons.minOf' call
          var a = fromInt(32);
          var tmp$ret$7 = a <= b ? a : b;
          this.z3x(data, 0n, tmp$ret$7);
          // Inline function 'kotlin.comparisons.minOf' call
          var a_0 = this.b3v_1;
          var tmp$ret$9 = a_0 <= limit ? a_0 : limit;
          throw EOFException().x3x('\\n not found: limit=' + tmp$ret$9.toString() + ' content=' + data.d3y().c3x() + '\u2026');
        }
        return tmp$ret$0;
      }
      l3y(options) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonSelect' call
          var index = selectPrefix(this, options);
          if (index === -1) {
            tmp$ret$0 = -1;
            break $l$block;
          }
          var selectedSize = options.j3v_1[index].q2();
          this.c3v(fromInt(selectedSize));
          tmp$ret$0 = index;
        }
        return tmp$ret$0;
      }
      m3y() {
        // Inline function 'okio.internal.commonReadByteArray' call
        return this.f3y(this.b3v_1);
      }
      f3y(byteCount) {
        // Inline function 'okio.internal.commonReadByteArray' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n && byteCount <= 2147483647n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.b3v_1 < byteCount)
          throw EOFException().c3y();
        var result = new Int8Array(convertToInt(byteCount));
        this.n3y(result);
        return result;
      }
      n3y(sink) {
        // Inline function 'okio.internal.commonReadFully' call
        var offset = 0;
        while (offset < sink.length) {
          var read = this.o3y(sink, offset, sink.length - offset | 0);
          if (read === -1)
            throw EOFException().c3y();
          offset = offset + read | 0;
        }
        return Unit_instance;
      }
      o3y(sink, offset, byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonRead' call
          checkOffsetAndCount(fromInt(sink.length), fromInt(offset), fromInt(byteCount));
          var tmp0_elvis_lhs = this.a3v_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$0 = -1;
            break $l$block;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var s = tmp;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = s.s3v_1 - s.r3v_1 | 0;
          var toCopy = Math.min(byteCount, b);
          var tmp0 = s.q3v_1;
          var tmp6 = s.r3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = s.r3v_1 + toCopy | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_0 = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp_0, sink, offset, tmp6, endIndex);
          s.r3v_1 = s.r3v_1 + toCopy | 0;
          this.b3v_1 = subtract(this.b3v_1, fromInt(toCopy));
          if (s.r3v_1 === s.s3v_1) {
            this.a3v_1 = s.a3w();
            SegmentPool_instance.i3w(s);
          }
          tmp$ret$0 = toCopy;
        }
        return tmp$ret$0;
      }
      a5() {
        // Inline function 'okio.internal.commonClear' call
        this.c3v(this.b3v_1);
        return Unit_instance;
      }
      c3v(byteCount) {
        // Inline function 'okio.internal.commonSkip' call
        var byteCount_0 = byteCount;
        while (byteCount_0 > 0n) {
          var tmp0_elvis_lhs = this.a3v_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().c3y();
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = byteCount_0;
          // Inline function 'okio.minOf' call
          var b = head.s3v_1 - head.r3v_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$1 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$1);
          this.b3v_1 = subtract(this.b3v_1, fromInt(toSkip));
          byteCount_0 = subtract(byteCount_0, fromInt(toSkip));
          head.r3v_1 = head.r3v_1 + toSkip | 0;
          if (head.r3v_1 === head.s3v_1) {
            this.a3v_1 = head.a3w();
            SegmentPool_instance.i3w(head);
          }
        }
        return Unit_instance;
      }
      p3y(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        var byteCount = byteString.q2();
        byteString.g3x(this, 0, byteCount);
        return this;
      }
      q3y(minimumCapacity) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonWritableSegment' call
          // Inline function 'kotlin.require' call
          if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
            var message = 'unexpected capacity';
            throw IllegalArgumentException().n2(toString(message));
          }
          if (this.a3v_1 == null) {
            var result = SegmentPool_instance.f3w();
            this.a3v_1 = result;
            result.w3v_1 = result;
            result.v3v_1 = result;
            tmp$ret$0 = result;
            break $l$block;
          }
          var tail = ensureNotNull(this.a3v_1).w3v_1;
          if ((ensureNotNull(tail).s3v_1 + minimumCapacity | 0) > 8192 || !tail.u3v_1) {
            tail = tail.b3w(SegmentPool_instance.f3w());
          }
          tmp$ret$0 = tail;
        }
        return tmp$ret$0;
      }
      r3y(string) {
        return this.s3y(string, 0, string.length);
      }
      s3y(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.require' call
        if (!(beginIndex >= 0)) {
          var message = 'beginIndex < 0: ' + beginIndex;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(endIndex >= beginIndex)) {
          var message_0 = 'endIndex < beginIndex: ' + endIndex + ' < ' + beginIndex;
          throw IllegalArgumentException().n2(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!(endIndex <= string.length)) {
          var message_1 = 'endIndex > string.length: ' + endIndex + ' > ' + string.length;
          throw IllegalArgumentException().n2(toString(message_1));
        }
        var i = beginIndex;
        while (i < endIndex) {
          // Inline function 'kotlin.code' call
          var this_0 = charCodeAt(string, i);
          var c = Char__toInt_impl_vasixd(this_0);
          if (c < 128) {
            var tail = this.q3y(1);
            var data = tail.q3v_1;
            var segmentOffset = tail.s3v_1 - i | 0;
            // Inline function 'kotlin.comparisons.minOf' call
            var b = 8192 - segmentOffset | 0;
            var runLimit = Math.min(endIndex, b);
            var tmp0 = i;
            i = tmp0 + 1 | 0;
            data[segmentOffset + tmp0 | 0] = toByte(c);
            $l$loop: while (i < runLimit) {
              // Inline function 'kotlin.code' call
              var this_1 = charCodeAt(string, i);
              c = Char__toInt_impl_vasixd(this_1);
              if (c >= 128)
                break $l$loop;
              var tmp1 = i;
              i = tmp1 + 1 | 0;
              data[segmentOffset + tmp1 | 0] = toByte(c);
            }
            var runSize = (i + segmentOffset | 0) - tail.s3v_1 | 0;
            tail.s3v_1 = tail.s3v_1 + runSize | 0;
            this.b3v_1 = add(this.b3v_1, fromInt(runSize));
          } else if (c < 2048) {
            var tail_0 = this.q3y(2);
            tail_0.q3v_1[tail_0.s3v_1] = toByte(c >> 6 | 192);
            tail_0.q3v_1[tail_0.s3v_1 + 1 | 0] = toByte(c & 63 | 128);
            tail_0.s3v_1 = tail_0.s3v_1 + 2 | 0;
            this.b3v_1 = add(this.b3v_1, 2n);
            i = i + 1 | 0;
          } else if (c < 55296 || c > 57343) {
            var tail_1 = this.q3y(3);
            tail_1.q3v_1[tail_1.s3v_1] = toByte(c >> 12 | 224);
            tail_1.q3v_1[tail_1.s3v_1 + 1 | 0] = toByte(c >> 6 & 63 | 128);
            tail_1.q3v_1[tail_1.s3v_1 + 2 | 0] = toByte(c & 63 | 128);
            tail_1.s3v_1 = tail_1.s3v_1 + 3 | 0;
            this.b3v_1 = add(this.b3v_1, 3n);
            i = i + 1 | 0;
          } else {
            var tmp;
            if ((i + 1 | 0) < endIndex) {
              // Inline function 'kotlin.code' call
              var this_2 = charCodeAt(string, i + 1 | 0);
              tmp = Char__toInt_impl_vasixd(this_2);
            } else {
              tmp = 0;
            }
            var low = tmp;
            if (c > 56319 || !(56320 <= low ? low <= 57343 : false)) {
              // Inline function 'kotlin.code' call
              var this_3 = _Char___init__impl__6a9atx(63);
              var tmp$ret$11 = Char__toInt_impl_vasixd(this_3);
              this.t3y(tmp$ret$11);
              i = i + 1 | 0;
            } else {
              var codePoint = 65536 + ((c & 1023) << 10 | low & 1023) | 0;
              var tail_2 = this.q3y(4);
              tail_2.q3v_1[tail_2.s3v_1] = toByte(codePoint >> 18 | 240);
              tail_2.q3v_1[tail_2.s3v_1 + 1 | 0] = toByte(codePoint >> 12 & 63 | 128);
              tail_2.q3v_1[tail_2.s3v_1 + 2 | 0] = toByte(codePoint >> 6 & 63 | 128);
              tail_2.q3v_1[tail_2.s3v_1 + 3 | 0] = toByte(codePoint & 63 | 128);
              tail_2.s3v_1 = tail_2.s3v_1 + 4 | 0;
              this.b3v_1 = add(this.b3v_1, 4n);
              i = i + 2 | 0;
            }
          }
        }
        return this;
      }
      u3y(source) {
        // Inline function 'okio.internal.commonWrite' call
        return this.q3w(source, 0, source.length);
      }
      q3w(source, offset, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        var offset_0 = offset;
        checkOffsetAndCount(fromInt(source.length), fromInt(offset_0), fromInt(byteCount));
        var limit = offset_0 + byteCount | 0;
        while (offset_0 < limit) {
          var tail = this.q3y(1);
          var tmp0 = limit - offset_0 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = 8192 - tail.s3v_1 | 0;
          var toCopy = Math.min(tmp0, b);
          var tmp2 = tail.q3v_1;
          var tmp4 = tail.s3v_1;
          var tmp6 = offset_0;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = offset_0 + toCopy | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = source;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, tmp4, tmp6, endIndex);
          offset_0 = offset_0 + toCopy | 0;
          tail.s3v_1 = tail.s3v_1 + toCopy | 0;
        }
        this.b3v_1 = add(this.b3v_1, fromInt(byteCount));
        return this;
      }
      h3v(source) {
        // Inline function 'okio.internal.commonWriteAll' call
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.v3y(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      t3y(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        var tail = this.q3y(1);
        var tmp1 = tail.s3v_1;
        tail.s3v_1 = tmp1 + 1 | 0;
        tail.q3v_1[tmp1] = toByte(b);
        this.b3v_1 = add(this.b3v_1, 1n);
        return this;
      }
      g3v(i) {
        // Inline function 'okio.internal.commonWriteInt' call
        var tail = this.q3y(4);
        var data = tail.q3v_1;
        var limit = tail.s3v_1;
        var tmp0 = limit;
        limit = tmp0 + 1 | 0;
        data[tmp0] = toByte((i >>> 24 | 0) & 255);
        var tmp1 = limit;
        limit = tmp1 + 1 | 0;
        data[tmp1] = toByte((i >>> 16 | 0) & 255);
        var tmp2 = limit;
        limit = tmp2 + 1 | 0;
        data[tmp2] = toByte((i >>> 8 | 0) & 255);
        var tmp3 = limit;
        limit = tmp3 + 1 | 0;
        data[tmp3] = toByte(i & 255);
        tail.s3v_1 = limit;
        this.b3v_1 = add(this.b3v_1, 4n);
        return this;
      }
      z3u(source, byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonWrite' call
          var byteCount_0 = byteCount;
          // Inline function 'kotlin.require' call
          if (!!(source === this)) {
            var message = 'source == this';
            throw IllegalArgumentException().n2(toString(message));
          }
          checkOffsetAndCount(source.b3v_1, 0n, byteCount_0);
          while (byteCount_0 > 0n) {
            if (byteCount_0 < fromInt(ensureNotNull(source.a3v_1).s3v_1 - ensureNotNull(source.a3v_1).r3v_1 | 0)) {
              var tail = !(this.a3v_1 == null) ? ensureNotNull(this.a3v_1).w3v_1 : null;
              var tmp;
              if (!(tail == null) && tail.u3v_1) {
                var tmp0 = byteCount_0;
                // Inline function 'kotlin.Long.plus' call
                var other = tail.s3v_1;
                var tmp0_0 = add(tmp0, fromInt(other));
                // Inline function 'kotlin.Long.minus' call
                var other_0 = tail.t3v_1 ? 0 : tail.r3v_1;
                tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
              } else {
                tmp = false;
              }
              if (tmp) {
                ensureNotNull(source.a3v_1).h3w(tail, convertToInt(byteCount_0));
                source.b3v_1 = subtract(source.b3v_1, byteCount_0);
                this.b3v_1 = add(this.b3v_1, byteCount_0);
                tmp$ret$0 = Unit_instance;
                break $l$block;
              } else {
                source.a3v_1 = ensureNotNull(source.a3v_1).c3w(convertToInt(byteCount_0));
              }
            }
            var segmentToMove = source.a3v_1;
            var movedByteCount = fromInt(ensureNotNull(segmentToMove).s3v_1 - segmentToMove.r3v_1 | 0);
            source.a3v_1 = segmentToMove.a3w();
            if (this.a3v_1 == null) {
              this.a3v_1 = segmentToMove;
              segmentToMove.w3v_1 = segmentToMove;
              segmentToMove.v3v_1 = segmentToMove.w3v_1;
            } else {
              var tail_0 = ensureNotNull(this.a3v_1).w3v_1;
              tail_0 = ensureNotNull(tail_0).b3w(segmentToMove);
              tail_0.g3w();
            }
            source.b3v_1 = subtract(source.b3v_1, movedByteCount);
            this.b3v_1 = add(this.b3v_1, movedByteCount);
            byteCount_0 = subtract(byteCount_0, movedByteCount);
          }
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      v3y(sink, byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonRead' call
          var byteCount_0 = byteCount;
          // Inline function 'kotlin.require' call
          if (!(byteCount_0 >= 0n)) {
            var message = 'byteCount < 0: ' + byteCount_0.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          if (this.b3v_1 === 0n) {
            tmp$ret$0 = -1n;
            break $l$block;
          }
          if (byteCount_0 > this.b3v_1)
            byteCount_0 = this.b3v_1;
          sink.z3u(this, byteCount_0);
          tmp$ret$0 = byteCount_0;
        }
        return tmp$ret$0;
      }
      k3y(b, fromIndex, toIndex) {
        var tmp$ret$0;
        $l$block_10: {
          // Inline function 'okio.internal.commonIndexOf' call
          var fromIndex_0 = fromIndex;
          var toIndex_0 = toIndex;
          // Inline function 'kotlin.require' call
          if (!(0n <= fromIndex_0 ? fromIndex_0 <= toIndex_0 : false)) {
            var message = 'size=' + this.b3v_1.toString() + ' fromIndex=' + fromIndex_0.toString() + ' toIndex=' + toIndex_0.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          if (toIndex_0 > this.b3v_1)
            toIndex_0 = this.b3v_1;
          if (fromIndex_0 === toIndex_0) {
            tmp$ret$0 = -1n;
            break $l$block_10;
          }
          var tmp2 = fromIndex_0;
          $l$block_11: {
            // Inline function 'okio.internal.seek' call
            var tmp0_elvis_lhs = this.a3v_1;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              var tmp_0;
              if (null == null) {
                tmp$ret$0 = -1n;
                break $l$block_10;
              } else {
                tmp_0 = null;
              }
              var s = tmp_0;
              var offset = -1n;
              while (offset < toIndex_0) {
                var data = s.q3v_1;
                var tmp0 = fromInt(s.s3v_1);
                // Inline function 'kotlin.comparisons.minOf' call
                var b_0 = subtract(add(numberToLong(s.r3v_1), toIndex_0), offset);
                var tmp$ret$5 = tmp0 <= b_0 ? tmp0 : b_0;
                var limit = convertToInt(tmp$ret$5);
                var pos = convertToInt(subtract(add(numberToLong(s.r3v_1), fromIndex_0), offset));
                while (pos < limit) {
                  if (data[pos] === b) {
                    tmp$ret$0 = add(numberToLong(pos - s.r3v_1 | 0), offset);
                    break $l$block_10;
                  }
                  pos = pos + 1 | 0;
                }
                offset = add(offset, fromInt(s.s3v_1 - s.r3v_1 | 0));
                fromIndex_0 = offset;
                s = ensureNotNull(s.v3v_1);
              }
              tmp$ret$0 = -1n;
              break $l$block_10;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var s_0 = tmp;
            if (subtract(this.b3v_1, tmp2) < tmp2) {
              var offset_0 = this.b3v_1;
              while (offset_0 > tmp2) {
                s_0 = ensureNotNull(s_0.w3v_1);
                offset_0 = subtract(offset_0, fromInt(s_0.s3v_1 - s_0.r3v_1 | 0));
              }
              var tmp0_0 = s_0;
              var offset_1 = offset_0;
              var tmp_1;
              if (tmp0_0 == null) {
                tmp$ret$0 = -1n;
                break $l$block_10;
              } else {
                tmp_1 = tmp0_0;
              }
              var s_1 = tmp_1;
              var offset_2 = offset_1;
              while (offset_2 < toIndex_0) {
                var data_0 = s_1.q3v_1;
                var tmp0_1 = fromInt(s_1.s3v_1);
                // Inline function 'kotlin.comparisons.minOf' call
                var b_1 = subtract(add(numberToLong(s_1.r3v_1), toIndex_0), offset_2);
                var tmp$ret$7 = tmp0_1 <= b_1 ? tmp0_1 : b_1;
                var limit_0 = convertToInt(tmp$ret$7);
                var pos_0 = convertToInt(subtract(add(numberToLong(s_1.r3v_1), fromIndex_0), offset_2));
                while (pos_0 < limit_0) {
                  if (data_0[pos_0] === b) {
                    tmp$ret$0 = add(numberToLong(pos_0 - s_1.r3v_1 | 0), offset_2);
                    break $l$block_10;
                  }
                  pos_0 = pos_0 + 1 | 0;
                }
                offset_2 = add(offset_2, fromInt(s_1.s3v_1 - s_1.r3v_1 | 0));
                fromIndex_0 = offset_2;
                s_1 = ensureNotNull(s_1.v3v_1);
              }
              tmp$ret$0 = -1n;
              break $l$block_10;
            } else {
              var offset_3 = 0n;
              $l$loop: while (true) {
                var tmp0_2 = offset_3;
                // Inline function 'kotlin.Long.plus' call
                var other = s_0.s3v_1 - s_0.r3v_1 | 0;
                var nextOffset = add(tmp0_2, fromInt(other));
                if (nextOffset > tmp2)
                  break $l$loop;
                s_0 = ensureNotNull(s_0.v3v_1);
                offset_3 = nextOffset;
              }
              var tmp0_3 = s_0;
              var offset_4 = offset_3;
              var tmp_2;
              if (tmp0_3 == null) {
                tmp$ret$0 = -1n;
                break $l$block_10;
              } else {
                tmp_2 = tmp0_3;
              }
              var s_2 = tmp_2;
              var offset_5 = offset_4;
              while (offset_5 < toIndex_0) {
                var data_1 = s_2.q3v_1;
                var tmp0_4 = fromInt(s_2.s3v_1);
                // Inline function 'kotlin.comparisons.minOf' call
                var b_2 = subtract(add(numberToLong(s_2.r3v_1), toIndex_0), offset_5);
                var tmp$ret$10 = tmp0_4 <= b_2 ? tmp0_4 : b_2;
                var limit_1 = convertToInt(tmp$ret$10);
                var pos_1 = convertToInt(subtract(add(numberToLong(s_2.r3v_1), fromIndex_0), offset_5));
                while (pos_1 < limit_1) {
                  if (data_1[pos_1] === b) {
                    tmp$ret$0 = add(numberToLong(pos_1 - s_2.r3v_1 | 0), offset_5);
                    break $l$block_10;
                  }
                  pos_1 = pos_1 + 1 | 0;
                }
                offset_5 = add(offset_5, fromInt(s_2.s3v_1 - s_2.r3v_1 | 0));
                fromIndex_0 = offset_5;
                s_2 = ensureNotNull(s_2.v3v_1);
              }
              tmp$ret$0 = -1n;
              break $l$block_10;
            }
          }
        }
        return tmp$ret$0;
      }
      w3y(bytes) {
        return this.x3y(bytes, 0n);
      }
      x3y(bytes, fromIndex) {
        var tmp$ret$0;
        $l$block_9: {
          // Inline function 'okio.internal.commonIndexOf' call
          var fromIndex_0 = fromIndex;
          // Inline function 'kotlin.require' call
          if (!(bytes.q2() > 0)) {
            var message = 'bytes is empty';
            throw IllegalArgumentException().n2(toString(message));
          }
          // Inline function 'kotlin.require' call
          if (!(fromIndex_0 >= 0n)) {
            var message_0 = 'fromIndex < 0: ' + fromIndex_0.toString();
            throw IllegalArgumentException().n2(toString(message_0));
          }
          var tmp2 = fromIndex_0;
          $l$block_10: {
            // Inline function 'okio.internal.seek' call
            var tmp0_elvis_lhs = this.a3v_1;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              var tmp_0;
              if (null == null) {
                tmp$ret$0 = -1n;
                break $l$block_9;
              } else {
                tmp_0 = null;
              }
              var s = tmp_0;
              var offset = -1n;
              var targetByteArray = bytes.b3x();
              var b0 = targetByteArray[0];
              var bytesSize = bytes.q2();
              // Inline function 'kotlin.Long.minus' call
              var this_0 = this.b3v_1;
              var tmp$ret$7 = subtract(this_0, fromInt(bytesSize));
              var resultLimit = add(tmp$ret$7, 1n);
              while (offset < resultLimit) {
                var data = s.q3v_1;
                var tmp0 = s.s3v_1;
                // Inline function 'okio.minOf' call
                var b = subtract(add(numberToLong(s.r3v_1), resultLimit), offset);
                // Inline function 'kotlin.comparisons.minOf' call
                var a = fromInt(tmp0);
                var tmp$ret$8 = a <= b ? a : b;
                var segmentLimit = convertToInt(tmp$ret$8);
                var inductionVariable = convertToInt(subtract(add(numberToLong(s.r3v_1), fromIndex_0), offset));
                if (inductionVariable < segmentLimit)
                  do {
                    var pos = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    if (data[pos] === b0 && rangeEquals(s, pos + 1 | 0, targetByteArray, 1, bytesSize)) {
                      tmp$ret$0 = add(numberToLong(pos - s.r3v_1 | 0), offset);
                      break $l$block_9;
                    }
                  }
                   while (inductionVariable < segmentLimit);
                offset = add(offset, fromInt(s.s3v_1 - s.r3v_1 | 0));
                fromIndex_0 = offset;
                s = ensureNotNull(s.v3v_1);
              }
              tmp$ret$0 = -1n;
              break $l$block_9;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var s_0 = tmp;
            if (subtract(this.b3v_1, tmp2) < tmp2) {
              var offset_0 = this.b3v_1;
              while (offset_0 > tmp2) {
                s_0 = ensureNotNull(s_0.w3v_1);
                offset_0 = subtract(offset_0, fromInt(s_0.s3v_1 - s_0.r3v_1 | 0));
              }
              var tmp0_0 = s_0;
              var offset_1 = offset_0;
              var tmp_1;
              if (tmp0_0 == null) {
                tmp$ret$0 = -1n;
                break $l$block_9;
              } else {
                tmp_1 = tmp0_0;
              }
              var s_1 = tmp_1;
              var offset_2 = offset_1;
              var targetByteArray_0 = bytes.b3x();
              var b0_0 = targetByteArray_0[0];
              var bytesSize_0 = bytes.q2();
              // Inline function 'kotlin.Long.minus' call
              var this_1 = this.b3v_1;
              var tmp$ret$11 = subtract(this_1, fromInt(bytesSize_0));
              var resultLimit_0 = add(tmp$ret$11, 1n);
              while (offset_2 < resultLimit_0) {
                var data_0 = s_1.q3v_1;
                var tmp0_1 = s_1.s3v_1;
                // Inline function 'okio.minOf' call
                var b_0 = subtract(add(numberToLong(s_1.r3v_1), resultLimit_0), offset_2);
                // Inline function 'kotlin.comparisons.minOf' call
                var a_0 = fromInt(tmp0_1);
                var tmp$ret$12 = a_0 <= b_0 ? a_0 : b_0;
                var segmentLimit_0 = convertToInt(tmp$ret$12);
                var inductionVariable_0 = convertToInt(subtract(add(numberToLong(s_1.r3v_1), fromIndex_0), offset_2));
                if (inductionVariable_0 < segmentLimit_0)
                  do {
                    var pos_0 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    if (data_0[pos_0] === b0_0 && rangeEquals(s_1, pos_0 + 1 | 0, targetByteArray_0, 1, bytesSize_0)) {
                      tmp$ret$0 = add(numberToLong(pos_0 - s_1.r3v_1 | 0), offset_2);
                      break $l$block_9;
                    }
                  }
                   while (inductionVariable_0 < segmentLimit_0);
                offset_2 = add(offset_2, fromInt(s_1.s3v_1 - s_1.r3v_1 | 0));
                fromIndex_0 = offset_2;
                s_1 = ensureNotNull(s_1.v3v_1);
              }
              tmp$ret$0 = -1n;
              break $l$block_9;
            } else {
              var offset_3 = 0n;
              $l$loop: while (true) {
                var tmp0_2 = offset_3;
                // Inline function 'kotlin.Long.plus' call
                var other = s_0.s3v_1 - s_0.r3v_1 | 0;
                var nextOffset = add(tmp0_2, fromInt(other));
                if (nextOffset > tmp2)
                  break $l$loop;
                s_0 = ensureNotNull(s_0.v3v_1);
                offset_3 = nextOffset;
              }
              var tmp0_3 = s_0;
              var offset_4 = offset_3;
              var tmp_2;
              if (tmp0_3 == null) {
                tmp$ret$0 = -1n;
                break $l$block_9;
              } else {
                tmp_2 = tmp0_3;
              }
              var s_2 = tmp_2;
              var offset_5 = offset_4;
              var targetByteArray_1 = bytes.b3x();
              var b0_1 = targetByteArray_1[0];
              var bytesSize_1 = bytes.q2();
              // Inline function 'kotlin.Long.minus' call
              var this_2 = this.b3v_1;
              var tmp$ret$16 = subtract(this_2, fromInt(bytesSize_1));
              var resultLimit_1 = add(tmp$ret$16, 1n);
              while (offset_5 < resultLimit_1) {
                var data_1 = s_2.q3v_1;
                var tmp0_4 = s_2.s3v_1;
                // Inline function 'okio.minOf' call
                var b_1 = subtract(add(numberToLong(s_2.r3v_1), resultLimit_1), offset_5);
                // Inline function 'kotlin.comparisons.minOf' call
                var a_1 = fromInt(tmp0_4);
                var tmp$ret$17 = a_1 <= b_1 ? a_1 : b_1;
                var segmentLimit_1 = convertToInt(tmp$ret$17);
                var inductionVariable_1 = convertToInt(subtract(add(numberToLong(s_2.r3v_1), fromIndex_0), offset_5));
                if (inductionVariable_1 < segmentLimit_1)
                  do {
                    var pos_1 = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    if (data_1[pos_1] === b0_1 && rangeEquals(s_2, pos_1 + 1 | 0, targetByteArray_1, 1, bytesSize_1)) {
                      tmp$ret$0 = add(numberToLong(pos_1 - s_2.r3v_1 | 0), offset_5);
                      break $l$block_9;
                    }
                  }
                   while (inductionVariable_1 < segmentLimit_1);
                offset_5 = add(offset_5, fromInt(s_2.s3v_1 - s_2.r3v_1 | 0));
                fromIndex_0 = offset_5;
                s_2 = ensureNotNull(s_2.v3v_1);
              }
              tmp$ret$0 = -1n;
              break $l$block_9;
            }
          }
        }
        return tmp$ret$0;
      }
      y3y(targetBytes) {
        return this.z3y(targetBytes, 0n);
      }
      z3y(targetBytes, fromIndex) {
        var tmp$ret$0;
        $l$block_12: {
          // Inline function 'okio.internal.commonIndexOfElement' call
          var fromIndex_0 = fromIndex;
          // Inline function 'kotlin.require' call
          if (!(fromIndex_0 >= 0n)) {
            var message = 'fromIndex < 0: ' + fromIndex_0.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          var tmp2 = fromIndex_0;
          $l$block_13: {
            // Inline function 'okio.internal.seek' call
            var tmp0_elvis_lhs = this.a3v_1;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              var tmp_0;
              if (null == null) {
                tmp$ret$0 = -1n;
                break $l$block_12;
              } else {
                tmp_0 = null;
              }
              var s = tmp_0;
              var offset = -1n;
              if (targetBytes.q2() === 2) {
                var b0 = targetBytes.r2(0);
                var b1 = targetBytes.r2(1);
                while (offset < this.b3v_1) {
                  var data = s.q3v_1;
                  var pos = convertToInt(subtract(add(numberToLong(s.r3v_1), fromIndex_0), offset));
                  var limit = s.s3v_1;
                  while (pos < limit) {
                    var b = data[pos];
                    if (b === b0 || b === b1) {
                      tmp$ret$0 = add(numberToLong(pos - s.r3v_1 | 0), offset);
                      break $l$block_12;
                    }
                    pos = pos + 1 | 0;
                  }
                  offset = add(offset, fromInt(s.s3v_1 - s.r3v_1 | 0));
                  fromIndex_0 = offset;
                  s = ensureNotNull(s.v3v_1);
                }
              } else {
                var targetByteArray = targetBytes.b3x();
                while (offset < this.b3v_1) {
                  var data_0 = s.q3v_1;
                  var pos_0 = convertToInt(subtract(add(numberToLong(s.r3v_1), fromIndex_0), offset));
                  var limit_0 = s.s3v_1;
                  while (pos_0 < limit_0) {
                    var b_0 = data_0[pos_0];
                    var inductionVariable = 0;
                    var last = targetByteArray.length;
                    while (inductionVariable < last) {
                      var t = targetByteArray[inductionVariable];
                      inductionVariable = inductionVariable + 1 | 0;
                      if (b_0 === t) {
                        tmp$ret$0 = add(numberToLong(pos_0 - s.r3v_1 | 0), offset);
                        break $l$block_12;
                      }
                    }
                    pos_0 = pos_0 + 1 | 0;
                  }
                  offset = add(offset, fromInt(s.s3v_1 - s.r3v_1 | 0));
                  fromIndex_0 = offset;
                  s = ensureNotNull(s.v3v_1);
                }
              }
              tmp$ret$0 = -1n;
              break $l$block_12;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var s_0 = tmp;
            if (subtract(this.b3v_1, tmp2) < tmp2) {
              var offset_0 = this.b3v_1;
              while (offset_0 > tmp2) {
                s_0 = ensureNotNull(s_0.w3v_1);
                offset_0 = subtract(offset_0, fromInt(s_0.s3v_1 - s_0.r3v_1 | 0));
              }
              var tmp0 = s_0;
              var offset_1 = offset_0;
              var tmp_1;
              if (tmp0 == null) {
                tmp$ret$0 = -1n;
                break $l$block_12;
              } else {
                tmp_1 = tmp0;
              }
              var s_1 = tmp_1;
              var offset_2 = offset_1;
              if (targetBytes.q2() === 2) {
                var b0_0 = targetBytes.r2(0);
                var b1_0 = targetBytes.r2(1);
                while (offset_2 < this.b3v_1) {
                  var data_1 = s_1.q3v_1;
                  var pos_1 = convertToInt(subtract(add(numberToLong(s_1.r3v_1), fromIndex_0), offset_2));
                  var limit_1 = s_1.s3v_1;
                  while (pos_1 < limit_1) {
                    var b_1 = data_1[pos_1];
                    if (b_1 === b0_0 || b_1 === b1_0) {
                      tmp$ret$0 = add(numberToLong(pos_1 - s_1.r3v_1 | 0), offset_2);
                      break $l$block_12;
                    }
                    pos_1 = pos_1 + 1 | 0;
                  }
                  offset_2 = add(offset_2, fromInt(s_1.s3v_1 - s_1.r3v_1 | 0));
                  fromIndex_0 = offset_2;
                  s_1 = ensureNotNull(s_1.v3v_1);
                }
              } else {
                var targetByteArray_0 = targetBytes.b3x();
                while (offset_2 < this.b3v_1) {
                  var data_2 = s_1.q3v_1;
                  var pos_2 = convertToInt(subtract(add(numberToLong(s_1.r3v_1), fromIndex_0), offset_2));
                  var limit_2 = s_1.s3v_1;
                  while (pos_2 < limit_2) {
                    var b_2 = data_2[pos_2];
                    var inductionVariable_0 = 0;
                    var last_0 = targetByteArray_0.length;
                    while (inductionVariable_0 < last_0) {
                      var t_0 = targetByteArray_0[inductionVariable_0];
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      if (b_2 === t_0) {
                        tmp$ret$0 = add(numberToLong(pos_2 - s_1.r3v_1 | 0), offset_2);
                        break $l$block_12;
                      }
                    }
                    pos_2 = pos_2 + 1 | 0;
                  }
                  offset_2 = add(offset_2, fromInt(s_1.s3v_1 - s_1.r3v_1 | 0));
                  fromIndex_0 = offset_2;
                  s_1 = ensureNotNull(s_1.v3v_1);
                }
              }
              tmp$ret$0 = -1n;
              break $l$block_12;
            } else {
              var offset_3 = 0n;
              $l$loop: while (true) {
                var tmp0_0 = offset_3;
                // Inline function 'kotlin.Long.plus' call
                var other = s_0.s3v_1 - s_0.r3v_1 | 0;
                var nextOffset = add(tmp0_0, fromInt(other));
                if (nextOffset > tmp2)
                  break $l$loop;
                s_0 = ensureNotNull(s_0.v3v_1);
                offset_3 = nextOffset;
              }
              var tmp0_1 = s_0;
              var offset_4 = offset_3;
              var tmp_2;
              if (tmp0_1 == null) {
                tmp$ret$0 = -1n;
                break $l$block_12;
              } else {
                tmp_2 = tmp0_1;
              }
              var s_2 = tmp_2;
              var offset_5 = offset_4;
              if (targetBytes.q2() === 2) {
                var b0_1 = targetBytes.r2(0);
                var b1_1 = targetBytes.r2(1);
                while (offset_5 < this.b3v_1) {
                  var data_3 = s_2.q3v_1;
                  var pos_3 = convertToInt(subtract(add(numberToLong(s_2.r3v_1), fromIndex_0), offset_5));
                  var limit_3 = s_2.s3v_1;
                  while (pos_3 < limit_3) {
                    var b_3 = data_3[pos_3];
                    if (b_3 === b0_1 || b_3 === b1_1) {
                      tmp$ret$0 = add(numberToLong(pos_3 - s_2.r3v_1 | 0), offset_5);
                      break $l$block_12;
                    }
                    pos_3 = pos_3 + 1 | 0;
                  }
                  offset_5 = add(offset_5, fromInt(s_2.s3v_1 - s_2.r3v_1 | 0));
                  fromIndex_0 = offset_5;
                  s_2 = ensureNotNull(s_2.v3v_1);
                }
              } else {
                var targetByteArray_1 = targetBytes.b3x();
                while (offset_5 < this.b3v_1) {
                  var data_4 = s_2.q3v_1;
                  var pos_4 = convertToInt(subtract(add(numberToLong(s_2.r3v_1), fromIndex_0), offset_5));
                  var limit_4 = s_2.s3v_1;
                  while (pos_4 < limit_4) {
                    var b_4 = data_4[pos_4];
                    var inductionVariable_1 = 0;
                    var last_1 = targetByteArray_1.length;
                    while (inductionVariable_1 < last_1) {
                      var t_1 = targetByteArray_1[inductionVariable_1];
                      inductionVariable_1 = inductionVariable_1 + 1 | 0;
                      if (b_4 === t_1) {
                        tmp$ret$0 = add(numberToLong(pos_4 - s_2.r3v_1 | 0), offset_5);
                        break $l$block_12;
                      }
                    }
                    pos_4 = pos_4 + 1 | 0;
                  }
                  offset_5 = add(offset_5, fromInt(s_2.s3v_1 - s_2.r3v_1 | 0));
                  fromIndex_0 = offset_5;
                  s_2 = ensureNotNull(s_2.v3v_1);
                }
              }
              tmp$ret$0 = -1n;
              break $l$block_12;
            }
          }
        }
        return tmp$ret$0;
      }
      a3z(offset, bytes) {
        return this.b3z(offset, bytes, 0, bytes.q2());
      }
      b3z(offset, bytes, bytesOffset, byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonRangeEquals' call
          if (offset < 0n || bytesOffset < 0 || byteCount < 0 || subtract(this.b3v_1, offset) < fromInt(byteCount) || (bytes.q2() - bytesOffset | 0) < byteCount) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var inductionVariable = 0;
          if (inductionVariable < byteCount)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'kotlin.Long.plus' call
              var tmp$ret$1 = add(offset, fromInt(i));
              if (!(this.o3w(tmp$ret$1) === bytes.r2(bytesOffset + i | 0))) {
                tmp$ret$0 = false;
                break $l$block_0;
              }
            }
             while (inductionVariable < byteCount);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      lc() {
        return Unit_instance;
      }
      l6() {
        return Unit_instance;
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_3: {
          // Inline function 'okio.internal.commonEquals' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_3;
          }
          if (!(other instanceof Buffer())) {
            tmp$ret$0 = false;
            break $l$block_3;
          }
          if (!(this.b3v_1 === other.b3v_1)) {
            tmp$ret$0 = false;
            break $l$block_3;
          }
          if (this.b3v_1 === 0n) {
            tmp$ret$0 = true;
            break $l$block_3;
          }
          var sa = ensureNotNull(this.a3v_1);
          var sb = ensureNotNull(other.a3v_1);
          var posA = sa.r3v_1;
          var posB = sb.r3v_1;
          var pos = 0n;
          var count;
          while (pos < this.b3v_1) {
            var tmp0 = sa.s3v_1 - posA | 0;
            // Inline function 'kotlin.comparisons.minOf' call
            var b = sb.s3v_1 - posB | 0;
            var tmp$ret$1 = Math.min(tmp0, b);
            count = fromInt(tmp$ret$1);
            var inductionVariable = 0n;
            if (inductionVariable < count)
              do {
                var i = inductionVariable;
                inductionVariable = add(inductionVariable, 1n);
                var tmp = sa.q3v_1;
                var tmp1 = posA;
                posA = tmp1 + 1 | 0;
                var tmp_0 = tmp[tmp1];
                var tmp_1 = sb.q3v_1;
                var tmp2 = posB;
                posB = tmp2 + 1 | 0;
                if (!(tmp_0 === tmp_1[tmp2])) {
                  tmp$ret$0 = false;
                  break $l$block_3;
                }
              }
               while (inductionVariable < count);
            if (posA === sa.s3v_1) {
              sa = ensureNotNull(sa.v3v_1);
              posA = sa.r3v_1;
            }
            if (posB === sb.s3v_1) {
              sb = ensureNotNull(sb.v3v_1);
              posB = sb.r3v_1;
            }
            pos = add(pos, count);
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      hashCode() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonHashCode' call
          var tmp0_elvis_lhs = this.a3v_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$0 = 0;
            break $l$block;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var s = tmp;
          var result = 1;
          do {
            var pos = s.r3v_1;
            var limit = s.s3v_1;
            while (pos < limit) {
              result = imul(31, result) + s.q3v_1[pos] | 0;
              pos = pos + 1 | 0;
            }
            s = ensureNotNull(s.v3v_1);
          }
           while (!(s === this.a3v_1));
          tmp$ret$0 = result;
        }
        return tmp$ret$0;
      }
      toString() {
        return this.c3z().toString();
      }
      c3z() {
        // Inline function 'okio.internal.commonSnapshot' call
        // Inline function 'kotlin.check' call
        if (!(this.b3v_1 <= 2147483647n)) {
          var message = 'size > Int.MAX_VALUE: ' + this.b3v_1.toString();
          throw IllegalStateException().o(toString(message));
        }
        return this.g3y(convertToInt(this.b3v_1));
      }
      g3y(byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonSnapshot' call
          if (byteCount === 0) {
            tmp$ret$0 = Companion_getInstance().w3w_1;
            break $l$block;
          }
          checkOffsetAndCount(this.b3v_1, 0n, fromInt(byteCount));
          var offset = 0;
          var segmentCount = 0;
          var s = this.a3v_1;
          while (offset < byteCount) {
            if (ensureNotNull(s).s3v_1 === s.r3v_1) {
              throw AssertionError().re('s.limit == s.pos');
            }
            offset = offset + (s.s3v_1 - s.r3v_1 | 0) | 0;
            segmentCount = segmentCount + 1 | 0;
            s = s.v3v_1;
          }
          // Inline function 'kotlin.arrayOfNulls' call
          var size = segmentCount;
          var segments = Array(size);
          var directory = new Int32Array(imul(segmentCount, 2));
          offset = 0;
          segmentCount = 0;
          s = this.a3v_1;
          while (offset < byteCount) {
            segments[segmentCount] = ensureNotNull(s).q3v_1;
            offset = offset + (s.s3v_1 - s.r3v_1 | 0) | 0;
            var tmp = segmentCount;
            // Inline function 'kotlin.comparisons.minOf' call
            var a = offset;
            directory[tmp] = Math.min(a, byteCount);
            directory[segmentCount + segments.length | 0] = s.r3v_1;
            s.t3v_1 = true;
            segmentCount = segmentCount + 1 | 0;
            s = s.v3v_1;
          }
          tmp$ret$0 = new (SegmentedByteString())(isArray(segments) ? segments : THROW_CCE(), directory);
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'Buffer', Buffer);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  UnsafeCursor as UnsafeCursor3vg8iqxvd6n5k,
  Buffer as Buffer3384y49aj0pxr,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
